export const GET_POSTCODE_PLAN_OBJECTIVE_LIST_PENDING = 'GET_POSTCODE_PLAN_OBJECTIVE_LIST_PENDING';
export const GET_POSTCODE_PLAN_OBJECTIVE_LIST_FETCHED = 'GET_POSTCODE_PLAN_OBJECTIVE_LIST_FETCHED';
export const GET_POSTCODE_PLAN_OBJECTIVE_LIST_REJECTED = 'GET_POSTCODE_PLAN_OBJECTIVE_LIST_RECETED';
export const GET_POSTCODE_PLAN_OBJECTIVE_META_PENDING = 'GET_POSTCODE_PLAN_OBJECTIVE_META_PENDING';
export const GET_POSTCODE_PLAN_OBJECTIVE_META_FETCHED = 'GET_POSTCODE_PLAN_OBJECTIVE_META_FETCHED';
export const GET_POSTCODE_PLAN_OBJECTIVE_META_REJECTED = 'GET_POSTCODE_PLAN_OBJECTIVE_META_REJECTED';
export const GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_PENDING = 'GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_PENDING';
export const GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_FETCHED = 'GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_FETCHED';
export const GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_REJECTED = 'GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_REJECTED';

export default function postcodePlanObjectives(
  state = {
    meta: {
      outlets: [],
      postcodeplan_objectives: []
    },
    fetching: false,
    fetched: false,
    postcodePlanObjective: {},
    errors: {},
    postcodePlanObjectives: [],
    filteredPostcodePlanObjectives: []
  },
  action
) {
  switch (action.type) {
    case GET_POSTCODE_PLAN_OBJECTIVE_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    }
    case GET_POSTCODE_PLAN_OBJECTIVE_LIST_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        postcodePlanObjectives: action.payload.data
      };
    }
    case GET_POSTCODE_PLAN_OBJECTIVE_LIST_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_POSTCODE_PLAN_OBJECTIVE_META_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_POSTCODE_PLAN_OBJECTIVE_META_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        meta: action.payload
      };
    }
    case GET_POSTCODE_PLAN_OBJECTIVE_META_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        filteredPostcodePlanObjectives: action.payload.data
      };
    }
    case GET_FILTERED_POSTCODE_PLAN_OBJECTIVE_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    default: {
      return { ...state };
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/postcodePlanObjectivesReducer.js